import { Injectable } from '@angular/core';

import { InlineAddConfig, InlineAddField } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class PurchaserAddConfigService {
  
  getPurchaserConfig(): InlineAddConfig {
    return {
      modelType: 'purchaser',
      title: 'Purchaser',
      apiEndpoint: 'api/purchasers/create',
      submitButtonText: 'Save',
      cancelButtonText: 'Cancel',
      fieldMapping: {
        'purchaserCode': 'code'
      },
      selectionConfig: {
        targetField: 'purchaserId',
        valueField: 'id',
        labelField: 'code'
      },
        hiddenData: {
        isActive: true,
        },
      fields: [
        {
          name: 'code',
          label: 'Purchaser #',
          type: 'text',
          required: true,
          maxLength: 50,
          placeholder: 'Enter purchaser number',
          size: 'half',
          isInstantData: true
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          maxLength: 250,
          placeholder: 'Enter purchaser name',
          size: 'half'
        },
        {
          name: 'isDefault',
          label: 'Default',
          type: 'switch',
          required: false,
          size: 'half',
          defaultValue: false
        }
      ]
    };
  }
}
